import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19dccdfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vue-tl-tlbs-commitment-agreement-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "So that things are super clean we would like you to be across some finer points so that you understand the following. ", -1 /* HOISTED */))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "I understand:", -1 /* HOISTED */))
const _hoisted_6 = { class: "content-cols" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Cancellation", -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "I can cancel my monthly enrolment fee in The School at any time with 3 month's notice to Thought Leaders. "),
  /*#__PURE__*/_createElementVNode("li", null, "Monthly or annual enrolment cannot be deferred or suspended."),
  /*#__PURE__*/_createElementVNode("li", null, "All fees are non-refundable, non-transferable, and cannot be used as credit or to redeem other services or events.")
], -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Prerequisites", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "The Curriculum"),
  /*#__PURE__*/_createTextVNode(": None")
], -1 /* HOISTED */))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "The School"),
  /*#__PURE__*/_createTextVNode(": The Curriculum")
], -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "The Program"),
  /*#__PURE__*/_createTextVNode(": Green Belt")
], -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Faculty"),
  /*#__PURE__*/_createTextVNode(": Black Belt")
], -1 /* HOISTED */))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h5", null, " Photography "),
  /*#__PURE__*/_createElementVNode("p", null, "Some sessions will be recorded, videoed and/or photographed, and these videos and images are made available to other students via Thought Leaders Central. Videos and images may also be used for brochures and websites (like the images on thoughtleaders.com.au)."),
  /*#__PURE__*/_createElementVNode("h5", null, " Bringing my team "),
  /*#__PURE__*/_createElementVNode("p", null, "I can register my practice manager to observe any of the virtual immersions with compliments of Thought Leaders.")
], -1 /* HOISTED */))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Payment Details ", -1 /* HOISTED */))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "New Students:"),
  /*#__PURE__*/_createTextVNode(" The School costs AUD $1500* per month. Confirmation of your enrolment is secured with a deposit of AUD $1500, which covers your first month in The School. Your deposit is non-refundable and valid for six months. Thereafter, your monthly payments will commence the month following your first virtual immersion and be charged on the 1st of each month. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://thoughtleaders.com.au/curriculum/",
    target: "_blank"
  }, "The Curriculum fee is a prerequisite to joining The School.")
], -1 /* HOISTED */))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Renewing Students:"),
  /*#__PURE__*/_createTextVNode(" AUD $1500* will be charged upon confirmation of your enrolment, and then monthly payments of AUD $1500* will commence on the 1st of the month thereafter")
], -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "*(plus GST for Australians)", -1 /* HOISTED */))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */))
const _hoisted_22 = { class: "agreement" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Otherwise "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:info@thoughtleaders.com.au" }, "email us.")
], -1 /* HOISTED */))
const _hoisted_25 = {
  key: 1,
  class: "joined"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Welcome to The School!", -1 /* HOISTED */))
const _hoisted_27 = {
  key: 2,
  class: "content-cols"
}
const _hoisted_28 = { class: "col" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Your details", -1 /* HOISTED */))
const _hoisted_30 = { class: "your-details" }
const _hoisted_31 = { class: "content-cols name-details" }
const _hoisted_32 = { class: "col" }
const _hoisted_33 = { class: "input-wrapper" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstname" }, "First name", -1 /* HOISTED */))
const _hoisted_35 = { class: "col" }
const _hoisted_36 = { class: "input-wrapper" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastname" }, "Last name", -1 /* HOISTED */))
const _hoisted_38 = { class: "input-wrapper" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1 /* HOISTED */))
const _hoisted_40 = {
  key: 0,
  class: "country-choice"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "country-choice" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Country")
], -1 /* HOISTED */))
const _hoisted_42 = ["value"]
const _hoisted_43 = { class: "immersion-choice" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "immersion-choice" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Choose your first immersion")
], -1 /* HOISTED */))
const _hoisted_45 = ["value"]
const _hoisted_46 = { class: "accepted-terms" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Terms & Conditions", -1 /* HOISTED */))
const _hoisted_48 = {
  for: "accepted-terms",
  class: "input-checkbox"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Your Signature", -1 /* HOISTED */))
const _hoisted_50 = { class: "col" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Pay Now", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TlbsInformationComponent = _resolveComponent("TlbsInformationComponent")!
  const _component_AuthLoggedInComponent = _resolveComponent("AuthLoggedInComponent")!
  const _component_SignatureComponent = _resolveComponent("SignatureComponent")!
  const _component_PlanPurchaseComponent = _resolveComponent("PlanPurchaseComponent")!
  const _component_SidebarComponent = _resolveComponent("SidebarComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_TlbsInformationComponent),
      _hoisted_3,
      _createElementVNode("section", null, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _renderSlot(_ctx.$slots, "slot-cancellation", {}, () => [
              _hoisted_9
            ], true),
            (!_ctx.isRenewal)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]),
          _hoisted_15
        ])
      ]),
      _hoisted_16,
      _createElementVNode("section", null, [
        _renderSlot(_ctx.$slots, "slot-payment-details", {}, () => [
          _hoisted_17,
          _hoisted_18,
          _hoisted_19,
          _hoisted_20
        ], true)
      ]),
      _hoisted_21,
      _createElementVNode("section", _hoisted_22, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.isRenewal ? "Renew" : "Join") + " The School ", 1 /* TEXT */),
        _hoisted_23,
        (_ctx.hasAlreadyPaid)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", null, "Looks like you've recently paid your " + _toDisplayString(_ctx.isRenewal ? "re-" : "") + "enrolment to The School. Please check your email for your program information.", 1 /* TEXT */),
              _hoisted_24
            ], 64 /* STABLE_FRAGMENT */))
          : (_ctx.joined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("p", null, "In the next five minutes you'll get an email confirming your " + _toDisplayString(_ctx.isRenewal ? "re-" : "") + "enrolment with your program information and a copy of your signed Commitment Agreement.", 1 /* TEXT */)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  (!_ctx.isRenewal)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_AuthLoggedInComponent, { not: true }, {
                          default: _withCtx(() => [
                            _hoisted_29,
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    _hoisted_34,
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentUser.FirstName) = $event)),
                                      type: "text",
                                      for: "firstname"
                                    }, null, 512 /* NEED_PATCH */), [
                                      [_vModelText, _ctx.currentUser.FirstName]
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, [
                                    _hoisted_37,
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentUser.LastName) = $event)),
                                      type: "text",
                                      for: "lastname"
                                    }, null, 512 /* NEED_PATCH */), [
                                      [_vModelText, _ctx.currentUser.LastName]
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _hoisted_39,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentUser.Email) = $event)),
                                  type: "email",
                                  for: "email"
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, _ctx.currentUser.Email]
                                ])
                              ])
                            ])
                          ]),
                          _: 1 /* STABLE */
                        }),
                        (_ctx.showCountries)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _hoisted_41,
                              _withDirectives(_createElementVNode("select", {
                                id: "country-choice",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.countryChoice) = $event)),
                                name: "country-choice"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (d) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: d.key,
                                    value: d.key
                                  }, _toDisplayString(d.value), 9 /* TEXT, PROPS */, _hoisted_42))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.countryChoice]
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _withDirectives(_createElementVNode("select", {
                            id: "immersion-choice",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.immersionChoice) = $event)),
                            name: "immersion-choice"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.upcomingSelectableImmersionDates, (d) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: d.key,
                                value: d.key
                              }, _toDisplayString(d.value), 9 /* TEXT, PROPS */, _hoisted_45))
                            }), 128 /* KEYED_FRAGMENT */))
                          ], 512 /* NEED_PATCH */), [
                            [_vModelSelect, _ctx.immersionChoice]
                          ])
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("label", _hoisted_48, [
                      _withDirectives(_createElementVNode("input", {
                        id: "accepted-terms",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.acceptedTerms) = $event)),
                        type: "checkbox"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelCheckbox, _ctx.acceptedTerms]
                      ]),
                      _createTextVNode(" I agree to the terms and conditions above ")
                    ])
                  ]),
                  _hoisted_49,
                  _createVNode(_component_SignatureComponent, { onChange: _ctx.signatureChanged }, null, 8 /* PROPS */, ["onChange"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createVNode(_component_SidebarComponent, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_PlanPurchaseComponent, {
                        disabled: !_ctx.canJoin,
                        "plan-ids": _ctx.planIds,
                        country: _ctx.countryChoice,
                        onPlanPurchased: _ctx.handlePlanPurchased,
                        onPlanPurchasing: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loading = true)),
                        onPlanPurchasedFailed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.loading = false))
                      }, {
                        "button-text-slot": _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isRenewal ? "Renew" : "Join") + " The School ", 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["disabled", "plan-ids", "country", "onPlanPurchased"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]))
      ])
    ]),
    _createVNode(_component_LoadingComponent, {
      loading: _ctx.loading,
      "full-screen": true
    }, null, 8 /* PROPS */, ["loading"])
  ], 64 /* STABLE_FRAGMENT */))
}